<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator'
    import {PRODUCT_NAME} from '@/utils/transfers/transfers-const'

    @Component
    export class TransferStoreMixin extends Vue {
        get productStore() {
            return transfersStore
        }

        get productRuntimeStore() {
            return transfersRuntimeStore
        }

        get productType() {
            return 'transfer'
        }

        get productName() {
            return PRODUCT_NAME
        }
    }

    export default TransferStoreMixin
</script>
